import { render, staticRenderFns } from "./EditParent.vue?vue&type=template&id=4568e2bd&scoped=true&"
import script from "./EditParent.vue?vue&type=script&lang=js&"
export * from "./EditParent.vue?vue&type=script&lang=js&"
import style0 from "./EditParent.vue?vue&type=style&index=0&id=4568e2bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4568e2bd",
  null
  
)

export default component.exports